import { Text, Field } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import withValidDatasourceCheck from 'lib/enhancers/withValidDatasourceCheck';

type Error500ThrowProps = ComponentProps & {
  fields: {
    heading: Field<string>;
  };
};

const Error500Throw = (props: Error500ThrowProps): React.JSX.Element => (
  <div>
    <p>Error500Throw Component</p>
    <Text field={props.fields.heading} />
  </div>
);

export default withValidDatasourceCheck()<Error500ThrowProps>(Error500Throw);
